import { useFormik } from "formik";
import { articleFormSchema } from "libs/validation/schemas";
import mediaUploader from "api/mediaUploader.api";
import useAuth from "hooks/useAuth";
import { CACHE_SIZE_UNLIMITED } from "firebase/firestore";
import { runFireworks } from "components/confetti";

const FIELDS = {
  TITLE: "title",
  DESCRIPTION: "description",
  IMAGES: "images",
  CONTENT: "content",
  CACHE_SIZE_UNLIMITED,
  CATEGORIES: "categories",
  WRITER: "writer",
  PLAN: "plan",
};

const useArticleForm = (props) => {
  const { article, create, update, id } = props;
  const { currentUser } = useAuth();
  const articleForm = useFormik({
    initialValues: {
      [FIELDS.TITLE]: article.title || "",
      [FIELDS.IMAGES]: article.images || {},
      [FIELDS.DESCRIPTION]: article.description || "",
      [FIELDS.CONTENT]: article.content || "",
      [FIELDS.CATEGORIES]: article.categories || [],
      [FIELDS.WRITER]: article.writer || "",
      [FIELDS.PLAN]: article.plan || "",
    },
    enableReinitialize: true,
    validationSchema: articleFormSchema,
    onSubmit: async (values) => {
      let thumbnailUrl = "";
      let coverUrl = "";
      let contentUrl = "";
      let planUrl = "";
      const slug = `${values[FIELDS.TITLE].toLowerCase().replaceAll(" ", "-")}`;
      if (typeof values[FIELDS.IMAGES]?.cover !== "string") {
        coverUrl = await mediaUploader(
          values[FIELDS.IMAGES]?.cover,
          `articles/covers/${slug}`,
        );
      }
      if (typeof values[FIELDS.IMAGES]?.thumbnail !== "string") {
        thumbnailUrl = await mediaUploader(
          values[FIELDS.IMAGES]?.thumbnail,
          `articles/thumbnails/${slug}`,
        );
      }

      if (typeof values[FIELDS.CONTENT]) {
        const blob = new Blob([values[FIELDS.CONTENT]], { type: "text/plain" });
        const file = new File([blob], `${slug}.txt`, { type: "text/plain" });
        contentUrl = await mediaUploader(file, `articles/content/${slug}`);
      }

      if (typeof values[FIELDS.PLAN] !== "string") {
        const blob = new Blob([values[FIELDS.PLAN]], {
          type: "application/pdf",
        });
        const file = new File([blob], `${id}.pdf`, {
          type: "application/pdf",
        });
        planUrl = await mediaUploader(file, `articles/plans/${id}`);
      }

      create({
        ...values,
        images: { thumbnail: thumbnailUrl, cover: coverUrl },
        createdAt: Date.now(),
        content: contentUrl,
        author: { id: currentUser?.id, displayName: currentUser.displayName },
        plan: planUrl,
      });
      update(id, {
        ...values,
        images: {
          thumbnail: thumbnailUrl || article.images.thumbnail,
          cover: coverUrl || article.images.cover,
        },
        content: contentUrl,
        updatedAt: Date.now(),
        plan: planUrl || article?.plan || "",
      });
      runFireworks();
    },
  });

  const { values, setFieldValue, handleSubmit, resetForm } = articleForm;

  return {
    articleForm,
    FIELDS,
    values,
    setFieldValue,
    handleSubmit,
    resetForm,
    errors: articleForm.errors,
  };
};

export default useArticleForm;
